// Реестр незаконченного ввода: открытые окна добавления и правки еды, форма
// продукта, набранный текст в чате. Пока он не пуст, автообновление
// приложения (utils/appUpdate.js) не перезагружает страницу при возврате из
// фона — до 14.10.2026 оно считало этот момент безопасным, а человек в нём
// как раз возвращался из буфера обмена к наполовину набранному приёму и терял
// его. Ключ — само окно (Symbol или объект), регистрация снимается при
// размонтировании.
import { ref } from 'vue'

const keys = new Set()

// Сколько окон держат незаконченный ввод; для шторок и отладки
export const unsavedCount = ref(0)

export function markUnsaved(key) {
  keys.add(key)
  unsavedCount.value = keys.size
}

export function clearUnsaved(key) {
  keys.delete(key)
  unsavedCount.value = keys.size
}

export function hasUnsaved() {
  return keys.size > 0
}

export function _reset() {
  keys.clear()
  unsavedCount.value = 0
}
